/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StationsStationsGetAllQueryResponse, StationsStationsGetAllQueryParams } from "../models/StationsStationsGetAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { stationsStationsGetAll } from "../axios/stationsStationsGetAll";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const stationsStationsGetAllQueryKey = (params: StationsStationsGetAllQueryParams = {}) => ["api-v2", { url: '/stations/v1' }, ...(params ? [params] : [])] as const

export type StationsStationsGetAllQueryKey = ReturnType<typeof stationsStationsGetAllQueryKey>

export function stationsStationsGetAllQueryOptions(params?: StationsStationsGetAllQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = stationsStationsGetAllQueryKey(params)
        return queryOptions<StationsStationsGetAllQueryResponse, ResponseErrorConfig<Error>, StationsStationsGetAllQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return stationsStationsGetAll(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns all stations accessible to the authenticated client or user.
 * @summary List stations
 * {@link /stations/v1}
 */
export function useStationsStationsGetAll<TData = StationsStationsGetAllQueryResponse, TQueryData = StationsStationsGetAllQueryResponse, TQueryKey extends QueryKey = StationsStationsGetAllQueryKey>(params?: StationsStationsGetAllQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<StationsStationsGetAllQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? stationsStationsGetAllQueryKey(params)
         

         const query = useQuery({
          ...stationsStationsGetAllQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}